import React, { createContext, useContext, useState } from 'react';

interface DashboardLayoutContextType {
    layoutMode: 'cards' | 'table';
    viewMode: 'last10' | 'paginated' | 'fullList';
    setLayoutMode: (mode: 'cards' | 'table') => void;
    setViewMode: (mode: 'last10' | 'paginated' | 'fullList') => void;
}

const DashboardLayoutContext = createContext<DashboardLayoutContextType>({
    layoutMode: 'cards',
    viewMode: 'last10',
    setLayoutMode: () => {},
    setViewMode: () => {},
});

export const DashboardLayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [layoutMode, setLayoutMode] = useState<'cards' | 'table'>('cards');
    const [viewMode, setViewMode] = useState<'last10' | 'paginated' | 'fullList'>('last10');
    return (
        <DashboardLayoutContext.Provider value={{ layoutMode, viewMode, setLayoutMode, setViewMode }}>
            {children}
        </DashboardLayoutContext.Provider>
    );
};

export const useDashboardLayout = () => useContext(DashboardLayoutContext);
export default DashboardLayoutContext;
